import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { organizationApi, accessCodeApi, adminApi } from '../../services/api';

interface Stats {
  organizations: number;
  accessCodes: number;
  admins: number;
}

export function AdminDashboard(): JSX.Element {
  const { user } = useAuth();
  const [stats, setStats] = useState<Stats>({ organizations: 0, accessCodes: 0, admins: 0 });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const [orgsRes, codesRes, adminsRes] = await Promise.all([
          organizationApi.getAll(),
          accessCodeApi.getAll(),
          adminApi.getAll(),
        ]);

        setStats({
          organizations: orgsRes.organizations?.length || 0,
          accessCodes: codesRes.accessCodes?.length || 0,
          admins: adminsRes.admins?.length || 0,
        });
      } catch (error) {
        console.error('Error loading stats:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadStats();
  }, []);

  if (isLoading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner"></div>
        <p>Laden...</p>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard</h1>

      <div className="welcome-section">
        <p>Willkommen, <strong>{user?.admin?.name}</strong>!</p>
        {user?.isSuperAdmin && (
          <p className="super-admin-note">Sie haben Super-Administrator Rechte.</p>
        )}
      </div>

      <div className="stats-grid">
        <Link to="/admin/organizations" className="stat-card">
          <div className="stat-icon">&#127970;</div>
          <div className="stat-value">{stats.organizations}</div>
          <div className="stat-label">Organisationen</div>
        </Link>

        <Link to="/admin/access-codes" className="stat-card">
          <div className="stat-icon">&#128273;</div>
          <div className="stat-value">{stats.accessCodes}</div>
          <div className="stat-label">Zugangscodes</div>
        </Link>

        <Link to="/admin/admins" className="stat-card">
          <div className="stat-icon">&#128100;</div>
          <div className="stat-value">{stats.admins}</div>
          <div className="stat-label">Administratoren</div>
        </Link>

        <Link to="/admin/settings" className="stat-card">
          <div className="stat-icon">&#9881;</div>
          <div className="stat-label">Einstellungen</div>
        </Link>
      </div>

      <div className="quick-actions">
        <h2>Schnellzugriff</h2>
        <div className="action-buttons">
          {user?.isSuperAdmin && (
            <>
              <Link to="/admin/organizations" className="btn btn-primary">
                Organisation erstellen
              </Link>
              <Link to="/admin/access-codes" className="btn btn-primary">
                Zugangscode erstellen
              </Link>
              <Link to="/admin/admins" className="btn btn-primary">
                Admin erstellen
              </Link>
            </>
          )}
          <Link to="/admin/settings" className="btn btn-secondary">
            Einstellungen verwalten
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
